import { render, staticRenderFns } from "./ForgotAccount.vue?vue&type=template&id=1b539be2&scoped=true&"
import script from "./ForgotAccount.vue?vue&type=script&lang=js&"
export * from "./ForgotAccount.vue?vue&type=script&lang=js&"
import style0 from "./ForgotAccount.vue?vue&type=style&index=0&id=1b539be2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b539be2",
  null
  
)

export default component.exports